import {
  CURRENT_ACTIVATION_FEE,
  LEGACY_ACTIVATION_FEE,
  PREVIOUS_CURRENT_ACTIVATION_FEE,
} from "../config/membershipConfig";
import { resolveActivationFeeForRoyalty } from "../config/activationRoyaltyConfig";

/**
 * First-time membership cashback equals activation fee tier (₹499 / ₹649 / ₹699).
 */
export function resolveFirstTimeMembershipCashbackAmount(order, pkg) {
  const fee = resolveActivationFeeForRoyalty(order, pkg);
  if (fee === LEGACY_ACTIVATION_FEE) return LEGACY_ACTIVATION_FEE;
  if (fee === PREVIOUS_CURRENT_ACTIVATION_FEE) {
    return PREVIOUS_CURRENT_ACTIVATION_FEE;
  }
  if (fee === CURRENT_ACTIVATION_FEE) return CURRENT_ACTIVATION_FEE;
  return CURRENT_ACTIVATION_FEE;
}

export function membershipCashbackTopUpAmount(earned, targetFee) {
  const earnedN = Number(earned) || 0;
  const target = Number(targetFee);
  if (target !== CURRENT_ACTIVATION_FEE) return 0;
  if (earnedN >= CURRENT_ACTIVATION_FEE) return 0;
  if (earnedN === LEGACY_ACTIVATION_FEE) {
    return CURRENT_ACTIVATION_FEE - LEGACY_ACTIVATION_FEE;
  }
  if (earnedN === PREVIOUS_CURRENT_ACTIVATION_FEE) {
    return CURRENT_ACTIVATION_FEE - PREVIOUS_CURRENT_ACTIVATION_FEE;
  }
  return 0;
}
